// import { Link } from 'react-router-dom';
import styled from 'styled-components';
export const ContainerFluid = styled.div`
// border:2px dashed red;
width:100%;
min-height:257px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1657123691/re-brand/Vector_vpsad6.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:top right;

`;

export const ContainerFluidB = styled.div`
// border:2px dashed red;
width:100%;
`;

export const ContainerFluidC = styled.div`
// border:2px dashed red;
margin-top:-200px;
width:100%;
min-height:368px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1657126424/re-brand/Frame_sfvqnr.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:top right;
`;

export const ContainerFluidGrid = styled.div`

// border:2px dashed red;
width:100%;
min-height:568px;
@media screen and (max-width: 425px) {
  width:auto !important;
}
`;

export const FluidGridA = styled.div`
// border:2px dashed red;
width:100%;
min-height:668px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1663522304/re-brand/Group_793_xbdevg.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:right;
.spax{
  width:90%;
  min-height:300px;
  // border:2px dashed red;
  padding-left:40px;
}
.spax-mob{
  display:none !important;
  visibility:hidden;
}
@media screen and (max-width: 768px) {
  padding-top:50px;
  .spax-mob{
    display:none !important;
    // border:2px dashed red;
    visibility:hidden;
  }
}
@media screen and (max-width: 425px) {
  padding-top:5px;
  .spax-mob{
    display:none !important;
    // border:2px dashed red;
    visibility:hidden;
  }
  background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1663522825/re-brand/Group_783_pm8sqt.svg');
  min-height:468px;
}
`;

export const FluidGridAA = styled.div`
// border:2px dashed red;
width:100%;
min-height:668px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1663685740/re-brand/Group_796_kkltwy.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:right;
.spax{
  width:90%;
  min-height:300px;
  // border:2px dashed red;
  padding-left:40px;
}
.spax-mob{
  display:none !important;
  visibility:hidden;
}
@media screen and (max-width: 1024px) {
  .spax{
    padding-left:20px;
    // border:2px dashed blue;
   
  }
}
@media screen and (max-width: 768px) {
  padding-top:50px;
  .spax-mob{
    display:none !important;
    // border:2px dashed red;
    visibility:hidden;
  }
}
@media screen and (max-width: 425px) {
  padding-top:5px;
  .spax-mob{
    display:none !important;
    // border:2px dashed red;
    visibility:hidden;
  }
  background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1663685875/re-brand/Group_780_tje7fz.svg');
  min-height:468px;
}
`;

export const FluidGridB = styled.div`
// border:2px dashed red;
width:100%;
min-height:668px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1663526379/re-brand/Group_794_s1szaq.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:right;
.spax{
  width:90%;
  min-height:300px;
  // border:2px dashed red;
  padding-left:50px;
}
.spax-mob{
  display:none !important;
  visibility:hidden;
}
@media screen and (max-width: 768px) {
  padding-top:50px;
  .spax-mob{
    display:none !important;
    // border:2px dashed red;
    visibility:hidden;
  }
}
@media screen and (max-width: 425px) {
  padding-top:5px;
  .spax-mob{
    display:none !important;
    // border:2px dashed red;
    visibility:hidden;
  }
  background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1663524138/re-brand/Group_782_gnen0w.svg');
  min-height:468px;
}
`;
export const FluidGridBB = styled.div`
// border:2px dashed red;
width:100%;
min-height:668px;
background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1663526379/re-brand/Group_794_s1szaq.svg');
background-size:contain;
background-repeat:no-repeat;
background-position:right;
.spax{
  width:90%;
  min-height:300px;
  // border:2px dashed red;
  padding-left:50px;
}
.spax-mob{
  display:none !important;
  visibility:hidden;
}
@media screen and (max-width: 768px) {
  padding-top:50px;
  .spax-mob{
    display:none !important;
    // border:2px dashed red;
    visibility:hidden;
  }
}
@media screen and (max-width: 425px) {
  padding-top:5px;
  .spax-mob{
    display:none !important;
    // border:2px dashed red;
    visibility:hidden;
  }
  background-image:url('https://res.cloudinary.com/yalla-ng/image/upload/v1663524138/re-brand/Group_782_gnen0w.svg');
  min-height:468px;
}
`;


export const Container = styled.div
.attrs(() => ({
  className: 'container-custom',
}))`
// border:2px dashed red;

`;

export const HeadingText = styled.h1
.attrs(() => ({
  className: '',
}))`
font-family: 'Cabinet Grotesk-bold';
font-style: normal;
font-weight: 800;
font-size: 36px;
line-height: 103%;
color: #282828;
margin-bottom:0px !important;
@media screen and (max-width: 425px) {
    width:auto !important;
}


`;
export const ParagraphText = styled.p
.attrs(() => ({
  className: '',
}))`

font-family: 'Cabinet Grotesk-regular', roboto;
font-style: normal;
font-weight: 800;
font-size:20px;
line-height: 142.5%;
color: #4A4A4A;
b{
font-family: 'Cabinet Grotesk-b', roboto;
font-weight: 500;
}
@media screen and (max-width: 425px) {
    width:auto !important;
}

`;